import React from 'react';

// Converts YYYY-MM-DD ➜ DD/MM/YYYY for display
export const toDisplayDate = (iso) => {
   if (!iso) return '';
   const [y, m, d] = iso.slice(0, 10).split('-');
   return `${d}/${m}/${y}`;
};

// Converts DD/MM/YYYY ➜ YYYY-MM-DD for API (returns null if incomplete)
export const toIsoDate = (display) => {
   if (!display) return null;
   const [d, m, y] = display.split('/');
   if (!d || !m || !y || y.length !== 4) return null;
   return `${y}-${m.padStart(2, '0')}-${d.padStart(2, '0')}`;
};

const formatInput = (raw) => {
   const digits = raw.replace(/\D/g, '').slice(0, 8);
   if (digits.length <= 2) return digits;
   if (digits.length <= 4) return `${digits.slice(0, 2)}/${digits.slice(2)}`;
   return `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4)}`;
};

/**
 * DateInput - displays and accepts dates in DD/MM/YYYY format.
 *
 * Props:
 *   label      - optional field label
 *   value      - DD/MM/YYYY string (controlled)
 *   onChange   - called with the new DD/MM/YYYY string
 *   required   - shows * on label
 *   className  - extra wrapper classes
 */
const DateInput = ({ label, value = '', onChange, required = false, className = '' }) => {
   const handleChange = (e) => {
      onChange(formatInput(e.target.value));
   };

   return (
      <div className={className}>
         {label && (
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1.5">
               {label} {required && <span className="text-red-500">*</span>}
            </label>
         )}
         <input
            type="text"
            value={value}
            onChange={handleChange}
            placeholder="DD/MM/YYYY"
            maxLength={10}
            className="w-full px-4 py-2 border rounded-lg bg-white dark:bg-dark-primary text-gray-900 dark:text-gray-100 placeholder-gray-400 dark:placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 dark:focus:ring-dark-accent focus:border-transparent border-gray-300 dark:border-gray-600"
         />
      </div>
   );
};

export default DateInput;
